// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dated"]
  connect() {
    liveSearch()
  }

  nextWeek(e) { this.refresh(e,  7 ) }
  prevWeek(e) { this.refresh(e,  -7 ) }
  next(e) { this.refresh(e,  1 ) }
  prev(e) { this.refresh(e,  -1 ) }

  refresh(e, days) {
    //
    // This catches the user changing the date by the Next/Prev buttons
    // Update both colums and the control date form 
    //
    e.preventDefault()
    let d = new Date( this.datedTarget.value )
    d = d.setDate( d.getDate() + days )
    this.datedTarget.value = new Date(d).toISOString().split("T")[0]
    document.querySelector("#control_date").closest('form').dispatchEvent(new Event('input'))
  }
}
